import { render, staticRenderFns } from "./ArchiveForm.vue?vue&type=template&id=184462e2&"
import script from "./ArchiveForm.vue?vue&type=script&lang=js&"
export * from "./ArchiveForm.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports